import { TextBody1 } from "common/components";
import { Column } from "common/components/Layout/new/constLayout";
import { ReactComponent as Logo } from "assets/logo/logo-with-text.svg";
import { t } from "i18next";
import styled from "styled-components";

export const MobilePage = () => {
  return (
    <OverlayLayout>
      <Column
        gap="1.5rem"
        style={{
          width: "60%",
          maxWidth: "30rem",
          alignItems: "center",
        }}>
        <Logo
          alt="logo"
          style={{ minWidth: "7.5rem", width: "40%", height: "50%" }}
        />
        <TextBody1
          style={{
            textAlign: "center",
            wordBreak: "keep-all",
            overflowWrap: "break-word",
          }}>
          {t("mobile")}
        </TextBody1>
      </Column>
    </OverlayLayout>
  );
};

const OverlayLayout = styled.div`
  display: none;
  @media (max-width: 1400px) {
    display: flex;
    position: fixed;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    height: 100dvh;
    background-color: var(--White);
    justify-content: center;
    align-items: center;
    text-align: center;
    z-index: 9999;
  }
`;
